import TEMPLATE_URL from 'emun.salesrep/territory-manager/territory/parser/territory-parser.htm'
import controller from 'emun.salesrep/territory-manager/territory/parser/territory-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'Territory Bulk Pad...',
    subTitle = 'Enter Territory IDs separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onTerritorySelected = NOOP,
    onTerritoryDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onTerritorySelected,
                onTerritoryDeselected,
                view,
            })
        }
    }).result;